import { defineCopy } from '@/i18n'

export default defineCopy('about', {
  id: {
    title: 'Tentang Kami',
    intro: {
      badge: 'Siapa Kami?',
      title: { pre: 'Selamat Datang di ', hl: 'Mira Solutions', post: '' },
      lead: 'Partner terpercaya Anda dalam dunia digital. Kami adalah tim profesional yang berkomitmen untuk menghadirkan solusi teknologi yang inovatif dan efektif, membantu bisnis Anda mencapai potensi terbaiknya.',
    },
    vision: {
      title: 'Visi Kami',
      text: 'Memudahkan bisnis dalam bertransformasi ke era digital. Kami percaya bahwa setiap perusahaan, besar atau kecil, berhak mendapatkan alat dan teknologi yang tepat untuk berkembang dan bersaing di pasar global.',
    },
    mission: {
      title: 'Misi Kami',
      text: 'Menghadirkan solusi teknologi berkualitas tinggi yang terjangkau. Membangunkan hubungan jangka panjang dengan klien melalui layanan yang prima dan inovatif.',
    },
    values: {
      badge: 'Keunggulan',
      title: { pre: 'Mengapa Memilih ', hl: 'Kami?', post: '' },
      items: {
        custom: { title: 'Solusi Kustom', desc: 'Setiap bisnis memiliki tantangan unik. Kami menawarkan solusi yang disesuaikan untuk kebutuhan spesifik Anda.' },
        team: { title: 'Tim Berpengalaman', desc: 'Tim kami terdiri dari profesional berpengalaman di bidang teknologi dan bisnis digital.' },
        responsive: { title: 'Layanan Responsif', desc: 'Kami berkomitmen untuk mendukung Anda di setiap langkah perjalanan digital Anda dengan layanan pelanggan yang responsif.' },
        security: { title: 'Keamanan Terjamin', desc: 'Kami menerapkan standar keamanan tinggi untuk melindungi data dan sistem Anda.' },
        results: { title: 'Hasil Terukur', desc: 'Setiap proyek kami dirancang untuk memberikan dampak yang terukur bagi bisnis Anda.' },
        innovation: { title: 'Inovasi Berkelanjutan', desc: 'Kami terus mengikuti perkembangan teknologi terbaru untuk memberikan solusi terbaik.' },
      },
    },
    cta: {
      title: 'Bergabunglah Bersama Kami!',
      text: 'Mari wujudkan visi digital Anda bersama Mira Solutions. Hubungi kami hari ini untuk mendiskusikan bagaimana kami dapat membantu bisnis Anda tumbuh dan sukses.',
      button: 'Hubungi Kami',
    },
  },
  en: {
    title: 'About Us',
    intro: {
      badge: 'Who We Are',
      title: { pre: 'Welcome to ', hl: 'Mira Solutions', post: '' },
      lead: 'Your trusted partner in the digital world. We are a team of professionals committed to delivering innovative, effective technology solutions that help your business reach its full potential.',
    },
    vision: {
      title: 'Our Vision',
      text: 'To make it easy for businesses to move into the digital era. We believe every company, large or small, deserves the right tools and technology to grow and compete in the global market.',
    },
    mission: {
      title: 'Our Mission',
      text: 'To deliver high-quality, affordable technology solutions, and to build long-term relationships with our clients through excellent, innovative service.',
    },
    values: {
      badge: 'Our Strengths',
      title: { pre: 'Why ', hl: 'Choose Us?', post: '' },
      items: {
        custom: { title: 'Custom Solutions', desc: 'Every business faces unique challenges. We offer solutions tailored to your specific needs.' },
        team: { title: 'Experienced Team', desc: 'Our team is made up of seasoned professionals in technology and digital business.' },
        responsive: { title: 'Responsive Service', desc: 'We are committed to supporting you at every step of your digital journey with responsive customer service.' },
        security: { title: 'Security Assured', desc: 'We apply high security standards to protect your data and systems.' },
        results: { title: 'Measurable Results', desc: 'Every project we take on is designed to make a measurable impact on your business.' },
        innovation: { title: 'Continuous Innovation', desc: 'We keep up with the latest technology to deliver the best solutions.' },
      },
    },
    cta: {
      title: 'Work With Us!',
      text: "Let's bring your digital vision to life with Mira Solutions. Contact us today to discuss how we can help your business grow and succeed.",
      button: 'Contact Us',
    },
  },
})
